module.exports = __webpack_public_path__ + "img/logo.56572fd6.svg";